module.exports = __webpack_public_path__ + "static/media/yingfuwu.6eae285f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/hardServices/yingfuwu.jpg
// module id = 472
// module chunks = 0